import { Prose } from '@/atoms';

import type { TypeTextColorVariant } from '@/components/types';
import type { FunctionComponent } from 'react';
import type { TypeSectionLegalProps } from './types';

const VARIANT_MAPS: Record<TypeTextColorVariant, string> = {
  primary: 'text-primary-400',
  secondary: 'text-secondary-400',
  alternative: 'text-white',
};

export const SectionLegal: FunctionComponent<TypeSectionLegalProps> = ({
  className = '',
  content,
  variant,
}: TypeSectionLegalProps) => (
  <div className={`flex flex-col gap-8 md:flex-col ${className}`}>
    {content ? (
      <Prose
        html={content}
        className={`flex flex-col gap-4 ${VARIANT_MAPS[variant]}`}
      />
    ) : null}
  </div>
);

SectionLegal.displayName = 'SectionLegal';
